<div class="ct-overlay" *ngIf="showModal">
    <div class="popup" >
        <div class="popup-header">
          <h2 class="title">Topic/Course Action Tab</h2>
          <button class="close-button" (click)="closeModal()">X</button>
        </div>
        <div class="popup-content">
          <div class="file-list">
            <div>Please select an option to delete, (Deleting any topic will delete all the courses mapped under the topic):</div>
            <div>
                <mat-radio-group aria-label="Select an option" [(ngModel)]="topicCourseModel">
                    <mat-radio-button value="Topic">Topic</mat-radio-button>
                    <mat-radio-button value="Course">Course</mat-radio-button>
                  </mat-radio-group>
                </div>
          </div>
        </div>
        <hr class="footer-line"> <!-- Line above footer -->
        <div class="popup-footer">
            <button class="btn btn-danger" (click)="deleteTopicCourse()" [disabled]="!topicCourseModel">Delete {{topicCourseModel}}</button>
          <button class="btn btn-secondary" (click)="closeModal()">Close Window</button>
        </div>
      </div>
</div>